import { render } from "./GraphReportV2.vue?vue&type=template&id=2c63fc4a&scoped=true"
import script from "./GraphReportV2.vue?vue&type=script&lang=js"
export * from "./GraphReportV2.vue?vue&type=script&lang=js"

import "./GraphReportV2.vue?vue&type=style&index=0&id=2c63fc4a&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c63fc4a"]])

export default __exports__